module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@3x-93b38218349f390688acb12e9a3368f4.webp";